import { api } from './client';

export const estoqueApi = {
  resumo: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/estoque/resumo${qs ? `?${qs}` : ''}`);
  },
  saldos: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/estoque/saldos${qs ? `?${qs}` : ''}`);
  },
  movimentacoes: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/estoque/movimentacoes${qs ? `?${qs}` : ''}`);
  },
  registrarMovimentacao: (dados) => api.post('/estoque/movimentacoes', dados),
  lotes: (produtoId) => api.get(`/estoque/lotes?produto_id=${produtoId}`),
  criarLote: (dados) => api.post('/estoque/lotes', dados)
};

export const depositosApi = {
  listar: () => api.get('/depositos'),
  criar: (dados) => api.post('/depositos', dados)
};

export const composicaoApi = {
  listar: (produtoId) => api.get(`/composicao/${produtoId}`),
  salvar: (produtoId, itens) => api.put(`/composicao/${produtoId}`, { itens })
};
